import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "row items-center q-pb-md" }
const _hoisted_2 = { class: "col-2 text-subtitle1 text-fun-label-and-icon" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col q-pr-md" }
const _hoisted_5 = { class: "col q-pl-md" }
const _hoisted_6 = { class: "row justify-between" }
const _hoisted_7 = { class: "row text-body1" }
const _hoisted_8 = { class: "col q-pr-md" }
const _hoisted_9 = { class: "row items-center q-pb-sm" }
const _hoisted_10 = { class: "row items-center q-pb-sm" }
const _hoisted_11 = { class: "row items-center q-pb-sm" }
const _hoisted_12 = { class: "row items-center q-pb-sm" }
const _hoisted_13 = { class: "row items-center" }
const _hoisted_14 = { class: "col q-pl-md" }
const _hoisted_15 = { class: "row items-center q-pb-sm" }
const _hoisted_16 = { class: "row items-center q-pb-sm" }
const _hoisted_17 = { class: "row items-center q-pb-sm" }
const _hoisted_18 = { class: "row items-center" }

import { useDialogPluginComponent } from "quasar"
import SfxBtn from "src/components/button/SfxBtn.vue"
import SfxBtnOutline from "src/components/button/SfxBtnOutline.vue"
import SfxSeparator from "src/components/special/SfxSeparator.vue"
import SfxToggleSettings from "src/components/toggle/SfxToggleSettings.vue"
import SfxSelect from "src/components/select/SfxSelect.vue"
import SfxPriorityFilter from "src/components/priority-filter/SfxPriorityFilter.vue"
import SfxBtnLink from "src/components/button/SfxBtnLink.vue"
import router from "src/router"
import { useFilterStore, WorkOrderPageFilters } from "src/stores/filterStore"
import { WORK_ORDER_FILTER_STATE } from "src/util/constants/filters"
import { ENTITY_TYPE, WORK_TYPE } from "src/util/enums/filters"
import { NamedManagerPath } from "src/util/enums/namedPaths"
import { getWorkDomainWorkspaceListData } from "src/util/functions/entityData"
import { WorkDomainWorkspace } from "src/util/types/dataModels/workDomain"
import SfxFilterSystemLink from "src/components/filter/SfxFilterSystemLink.vue"
import { onBeforeMount, reactive, ref } from "vue"
import { useI18n } from "vue-i18n"

//region Props and Emits
//endregion

//region Variables


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxDialogFilterWorkOrders',
  setup(__props) {

const { t } = useI18n()
const filterStore = useFilterStore()
const { dialogRef, onDialogOK, onDialogCancel } = useDialogPluginComponent()

const workDomainOptions = ref<WorkDomainWorkspace[]>([])

const workOrderPageFilters = reactive<WorkOrderPageFilters>({ ...filterStore.workOrderPageFilters })

//endregion

//region Lifecycle

onBeforeMount(async () => {
  const workDomains = await getWorkDomainWorkspaceListData()
  workDomainOptions.value = workDomains.map((workDomain) => workDomain.toMutableJSON())
})

//endregion

//region Functions

function handleSystemLinkClose() {
  workOrderPageFilters.systemLink = undefined
  filterStore.workOrderPageFilters.systemLink = undefined
}

function saveFilters() {
  filterStore.workOrderPageFilters = workOrderPageFilters

  // Set the flag value
  filterStore.workOrderPageFilters.hasFilters = true

  onDialogOK()

  router.replace({
    name: NamedManagerPath.SELECT_WORK_ORDER,
    query: {
      filters: JSON.stringify(filterStore.workOrderPageFilters),
    },
  })
}

function selectAll() {
  workOrderPageFilters.state = WORK_ORDER_FILTER_STATE
}

function selectNone() {
  workOrderPageFilters.state = []
}

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef,
    class: "sfx-dialog-filter"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "q-dialog-plugin" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "text-h3 q-pb-lg" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("sfxDialogFilter.title_filter_work_orders")), 1)
            ]),
            _: 1
          }),
          (workOrderPageFilters.systemLink)
            ? (_openBlock(), _createBlock(_component_q_card_section, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(SfxFilterSystemLink, {
                    "system-link": workOrderPageFilters.systemLink,
                    onRemove: _cache[0] || (_cache[0] = ($event: any) => (handleSystemLinkClose()))
                  }, null, 8, ["system-link"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)("sfxDialogFilter.work_domain")), 1),
                _createVNode(SfxSelect, {
                  class: "col-10",
                  placeholder: _unref(t)('sfxDialogFilter.place_holder_work_domain'),
                  modelValue: workOrderPageFilters.workDomain,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((workOrderPageFilters.workDomain) = $event)),
                  options: workDomainOptions.value,
                  "option-label": (opt) => opt.designation,
                  "option-value": (opt) => opt.id,
                  loading: workDomainOptions.value?.length === 0,
                  "emit-value": "",
                  "map-options": "",
                  "use-chips": "",
                  multiple: ""
                }, null, 8, ["placeholder", "modelValue", "options", "option-label", "option-value", "loading"])
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(SfxToggleSettings, {
                    class: "q-py-none",
                    html: "",
                    trinary: "",
                    modelValue: workOrderPageFilters.workType,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((workOrderPageFilters.workType) = $event)),
                    description: _unref(t)('sfxDialogFilter.work_type'),
                    "true-value": _unref(WORK_TYPE).REGULAR,
                    "true-label": _unref(t)('sfxDialogFilter.regular'),
                    "false-value": _unref(WORK_TYPE).CORRECTIVE,
                    "false-label": _unref(t)('sfxDialogFilter.corrective'),
                    "indeterminate-value": _unref(WORK_TYPE).EITHER,
                    "indeterminate-label": _unref(t)('sfxDialogFilter.either')
                  }, null, 8, ["modelValue", "description", "true-value", "true-label", "false-value", "false-label", "indeterminate-value", "indeterminate-label"])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(SfxToggleSettings, {
                    class: "q-py-none",
                    html: "",
                    trinary: "",
                    modelValue: workOrderPageFilters.entityType,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((workOrderPageFilters.entityType) = $event)),
                    description: _unref(t)('sfxDialogFilter.entity_type'),
                    "true-value": _unref(ENTITY_TYPE).ITEM,
                    "true-label": _unref(t)('sfxDialogFilter.item'),
                    "false-value": _unref(ENTITY_TYPE).AREA,
                    "false-label": _unref(t)('sfxDialogFilter.area'),
                    "indeterminate-value": _unref(ENTITY_TYPE).EITHER,
                    "indeterminate-label": _unref(t)('sfxDialogFilter.either'),
                    disable: ""
                  }, null, 8, ["modelValue", "description", "true-value", "true-label", "false-value", "false-label", "indeterminate-value", "indeterminate-label"])
                ])
              ]),
              _createVNode(SfxSeparator, { class: "sfx-separator-text" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("sfxDialogFilter.priorities")), 1)
                ]),
                _: 1
              }),
              _createVNode(SfxPriorityFilter, {
                modelValue: workOrderPageFilters.priority,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((workOrderPageFilters.priority) = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(SfxSeparator, { class: "sfx-separator-text" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("sfxDialogFilter.states")), 1)
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(SfxBtnLink, {
                  class: "q-pl-none",
                  label: _unref(t)('sfxButtons.btn_select_none'),
                  onClick: selectNone
                }, null, 8, ["label"]),
                _createVNode(SfxBtnLink, {
                  class: "q-pr-none",
                  label: _unref(t)('sfxButtons.btn_select_all'),
                  onClick: selectAll
                }, null, 8, ["label"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", null, _toDisplayString(_unref(t)("sfxDialogFilter.draft_work_order")), 1),
                    _createVNode(_component_q_space),
                    _createVNode(_component_q_checkbox, {
                      modelValue: workOrderPageFilters.state,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((workOrderPageFilters.state) = $event)),
                      val: "draft",
                      size: "48px",
                      color: "secondary",
                      dense: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", null, _toDisplayString(_unref(t)("sfxDialogFilter.open")), 1),
                    _createVNode(_component_q_space),
                    _createVNode(_component_q_checkbox, {
                      modelValue: workOrderPageFilters.state,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((workOrderPageFilters.state) = $event)),
                      val: "open",
                      size: "48px",
                      color: "secondary",
                      dense: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", null, _toDisplayString(_unref(t)("sfxDialogFilter.behind")), 1),
                    _createVNode(_component_q_space),
                    _createVNode(_component_q_checkbox, {
                      modelValue: workOrderPageFilters.state,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((workOrderPageFilters.state) = $event)),
                      val: "behind",
                      size: "48px",
                      color: "secondary",
                      dense: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", null, _toDisplayString(_unref(t)("sfxDialogFilter.complete")), 1),
                    _createVNode(_component_q_space),
                    _createVNode(_component_q_checkbox, {
                      modelValue: workOrderPageFilters.state,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((workOrderPageFilters.state) = $event)),
                      val: "complete",
                      size: "48px",
                      color: "secondary",
                      dense: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", null, _toDisplayString(_unref(t)("sfxDialogFilter.completed_closed")), 1),
                    _createVNode(_component_q_space),
                    _createVNode(_component_q_checkbox, {
                      modelValue: workOrderPageFilters.state,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((workOrderPageFilters.state) = $event)),
                      val: "complete_closed",
                      size: "48px",
                      color: "secondary",
                      dense: ""
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", null, _toDisplayString(_unref(t)("sfxDialogFilter.planned")), 1),
                    _createVNode(_component_q_space),
                    _createVNode(_component_q_checkbox, {
                      modelValue: workOrderPageFilters.state,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((workOrderPageFilters.state) = $event)),
                      val: "planned",
                      size: "48px",
                      color: "secondary",
                      dense: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", null, _toDisplayString(_unref(t)("sfxDialogFilter.in_progress")), 1),
                    _createVNode(_component_q_space),
                    _createVNode(_component_q_checkbox, {
                      modelValue: workOrderPageFilters.state,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((workOrderPageFilters.state) = $event)),
                      val: "in_progress",
                      size: "48px",
                      color: "secondary",
                      dense: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", null, _toDisplayString(_unref(t)("sfxDialogFilter.overdue")), 1),
                    _createVNode(_component_q_space),
                    _createVNode(_component_q_checkbox, {
                      modelValue: workOrderPageFilters.state,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((workOrderPageFilters.state) = $event)),
                      val: "overdue",
                      size: "48px",
                      color: "secondary",
                      dense: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", null, _toDisplayString(_unref(t)("sfxDialogFilter.closed")), 1),
                    _createVNode(_component_q_space),
                    _createVNode(_component_q_checkbox, {
                      modelValue: workOrderPageFilters.state,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((workOrderPageFilters.state) = $event)),
                      val: "closed",
                      size: "48px",
                      color: "secondary",
                      dense: ""
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_actions, { class: "row justify-center q-pa-md" }, {
            default: _withCtx(() => [
              _createVNode(SfxBtnOutline, {
                class: "col-4 q-mr-sm",
                onClick: _unref(onDialogCancel),
                label: _unref(t)('sfxButtons.btn_close')
              }, null, 8, ["onClick", "label"]),
              _createVNode(SfxBtn, {
                class: "col-4",
                onClick: saveFilters,
                label: _unref(t)('sfxButtons.btn_apply_changes')
              }, null, 8, ["label"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}
}

})